export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        gtag() {
          window.dataLayer.push(arguments)
        }
      }
    })
  }
}
